import { render } from "./publish_portal.html?vue&type=template&id=8a4f82b2&external"
import script from "./publish_portal.js?vue&type=script&lang=js&external"
export * from "./publish_portal.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__